import { IDeleteFuncionarioTreinamentoUseCase } from "../../../presentation/useCases/delete/delete_funcionario_treinamento_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";



export class DeleteFuncionarioTreinamentoUseCase implements IDeleteFuncionarioTreinamentoUseCase {
  constructor(
    private readonly repository: ITerceirizacaoRepository,
  ) { }

  async deleteFuncionarioTreinamento(idFuncionarioTreinamento: number): Promise<void> {
    await this.repository.deleteFuncionarioTreinamento(idFuncionarioTreinamento);
  }
}
